import Vue from 'vue'
import Vuex from 'vuex'
// import deneme from '@/stores/deneme';

Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,

  modules: {
    // deneme
  },

  state: {

  },
  mutations: {

  },
  actions: {

  }
})
